const featuredProductCodeParam = 'featuredProductCode';

export const setFeaturedProductParamOnURL = (urlString: string, productCode: string | number) => {
  const [baseUrl, queryString] = urlString.split('?');
  const searchParams = new URLSearchParams(queryString);

  searchParams.set(featuredProductCodeParam, productCode.toString());

  return `${baseUrl}?${searchParams.toString()}`;
};
